import SeameUI from '@seame/ui'

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.use(SeameUI)
})
